export default __webpack_public_path__ + "static/essential-qualities-to-look-for-in-an-IT-provider-935e9513ae9768c095c895995f18c005.pdf";